import { forwardRef } from 'react';
import useStyles from './AppPaperTitle.styles';
import { BoxProps, Box, Typography } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

type CustomAppPaperTitleProps = {};

type AppPaperTitleProps = Omit<BoxProps, keyof CustomAppPaperTitleProps> & CustomAppPaperTitleProps;

type AppPaperTitleTypeMap<P = {}, D extends React.ElementType = 'div'> = {
  props: AppPaperTitleProps & P;
  defaultComponent: D;
};
type AppPaperTitleComponent = OverridableComponent<AppPaperTitleTypeMap>;

const AppPaperTitle = forwardRef((props: AppPaperTitleProps, ref: React.ForwardedRef<any>) => {
  const { classes, cx } = useStyles();
  const { children, className, ...rest } = props;

  return (
    <Box ref={ref} {...rest} className={cx(classes.root, className)}>
      <Typography className={classes.title} variant="h6">
        {children}
      </Typography>
    </Box>
  );
}) as AppPaperTitleComponent;

export default AppPaperTitle;
